import { useStorage as useStorageVueUse } from '@vueuse/core'
import type { PiniaPluginContext } from 'pinia'
import type { CheckoutOrderModel } from '@/models/checkout-order-model'

export const orderPiniaPlugin = async (context: PiniaPluginContext) => {
  if (process.client && context.store.$id === 'order') {
    const DEFAULT_ORDER: CheckoutOrderModel = {
      isSubscribedToNewsletter: false,
      orderCode: null,
      preOrderCode: null,
      isWhatsAppPreferredContact: false,
    }
    const orderLocalStorage = useStorageVueUse<CheckoutOrderModel>('order-storage', DEFAULT_ORDER)
    if (orderLocalStorage.value && orderLocalStorage.value.preOrderCode)
      context.store.$state.orderData = orderLocalStorage.value

    context.store.$subscribe(() => orderLocalStorage.value = context.store.$state.orderData)
  }
}
